import React from 'react';

import Input, { InputType } from 'widget/shared/ui/Input';
import { WidgetContactFormFieldType } from 'widget/entities/config';
import { WidgetTexts } from 'widget/consts/texts';
import { FormContactField } from 'widget/types/submissionFormState';
import {
  TypographyWeight,
  TypographySize
} from 'widget/shared/ui/Typography/types';

const INPUT_TYPE_MAP: Record<WidgetContactFormFieldType, InputType> = {
  [WidgetContactFormFieldType.phone]: 'tel',
  [WidgetContactFormFieldType.email]: 'email',
  [WidgetContactFormFieldType.name]: 'text'
};

type Props = {
  field: FormContactField;
  value: string;
  error: string | null;
  disabled: boolean;
  onChangeField: (type: WidgetContactFormFieldType, value: string) => void;
  onBlurField: (type: WidgetContactFormFieldType) => void;
};

const ContactFormItem: React.FC<Props> = ({
  field,
  value,
  error,
  disabled,
  onChangeField,
  onBlurField
}) => {
  const fieldTexts = WidgetTexts.submissionForm.fields[field.type];
  const inputType = INPUT_TYPE_MAP[field.type] || 'text';

  const handleChange = React.useCallback(
    (newValue: string) => {
      onChangeField(field.type, newValue);
    },
    [onChangeField, field.type]
  );

  const handleBlur = React.useCallback(() => {
    onBlurField(field.type);
  }, [onBlurField, field.type]);

  return (
    <Input
      type={inputType}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={fieldTexts.placeholder}
      label={fieldTexts.label}
      error={error}
      required={field.required}
      disabled={disabled}
      fontSize={TypographySize.s}
      fontWeight={TypographyWeight.medium}
      withClear
    />
  );
};

export default React.memo(ContactFormItem);
